import { Link } from "react-router-dom"
import Logo from "../components/Logo"
import Card from "../components/Card"
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Visible from "../components/Svg/Visible"
import NotVisible from "../components/Svg/NotVisible"
import Button from "../components/Button"
import useForm from "../useForm"
import usePassword from "../usePassword"


function SignUp() {
  const {handleChange, values, errors, handleSubmit, message, errmsg } = useForm({
    firstname: '',
    lastname: '',
    phone_number: '',
    country_code: 'NGN',
    country: '',
    email:'',
    username: '',
    password: '',
    confirm_password: ''
 });
  const {showPassword, handleShowPassword, showConfirmPassword, handleHidePassword, handleShowConfirmPassword, handleHideConfirmPassword, } = usePassword(false);

 

  return (
    <div className='signup-container'>
      <Logo />
      <Card>
      {message ? <p className="text-success my-3">{message}</p> : 
      <p className="text-danger my-3">{errmsg}</p>}
           <h4 className="card-head">
               Create Account
               </h4>
           <p className="card-text"> 
           Enter your Personal information to create account on Payourl
           </p>
            <form onSubmit={handleSubmit}>
                  <input
                      className={errors?.firstname ? "error signup-input gen-input" : "signup-input gen-input"}
                      type="text" 
                      placeholder='First name'
                      name="firstname"
                      id="firstname"
                      value={values.firstname}
                      onChange={handleChange}
                      />
                      {errors?.firstname && <p className="small">{errors.firstname}</p>}
                  <input
                      className={errors?.lastname ? "error signup-input gen-input" : "signup-input gen-input"}
                      type="text" 
                      placeholder='Last name'
                      name="lastname"
                      id="lastName"
                      value={values.lastame}
                      onChange={handleChange}/>
                        {errors?.lastname && <p className="small">{errors.lastname}</p>}
                        <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon1">@</InputGroup.Text>
                        <FormControl
                          className={errors?.username ? "error form-control" : "form-control"}
                          placeholder="Username"
                          aria-label="Username"
                          aria-describedby="basic-addon1"
                          name="username"
                          value={values.username}
                          onChange={handleChange}
                        />
                  </InputGroup>
                  {errors?.username && <p className="small">{errors.username}</p>}
                  <InputGroup>
                        <Form.Select 
                        aria-label="Default select example" 
                        id='country-code'
                        name="country_code"
                        value='NGN'
                        onChange={handleChange}>
                          <option value="NGN">🇳🇬</option>
                        </Form.Select>
                        <FormControl
                        type="tel" 
                        className={errors?.phone_number ? "error form-control" : "form-control"}
                        aria-label="Text input with dropdown button" 
                        placeholder="+234" 
                        name="phone_number"
                        id="phoneNumber"
                        value={values.phoneNumber}
                        onChange={handleChange}
                        />
                  </InputGroup>
                    {errors?.phone_number && <p className="small">{errors.phone_number}</p>}
                   <input
                      className={errors?.country ? "error signup-input gen-input" : "signup-input gen-input"}
                      type="text" 
                      placeholder='Country'
                      name="country"
                      id="country"
                      value={values.country}
                      onChange={handleChange}/>
                      {errors?.country && <p className="small">{errors.country}</p>}
                   <input
                      className={errors?.email ? "error signup-input gen-input" : "signup-input gen-input"}
                      type="email" 
                      placeholder='Email'
                      name="email"
                      id="email"
                      value={values.email}
                      onChange={handleChange}/>
                      {errors?.email && <p className="small">{errors.email}</p>}
                  
                   <div className="password-input-group">
                          <input 
                          className={errors?.password ? "error signup-input gen-input" : "signup-input gen-input"}
                          type={showPassword ? "text" : "password"}
                          placeholder="Password"
                          name="password"
                          id="password" 
                          value={values.password}
                          onChange={handleChange}/>
                             {showPassword ?
                              <div className="gs-not-visible-group" onClick={handleHidePassword}>
                              <NotVisible stroke="#7A8996"/>
                            </div> : 
                            <div className="gs-visible-group" onClick={handleShowPassword}>
                            <Visible fill="#7A8996" />
                          </div>}
                    </div>
                    {errors?.password && <p className="small">{errors.password}</p>}
                    <div className="password-input-group">
                          <input 
                          className={errors?.confirm_password ? "error signup-input gen-input" : "signup-input gen-input"}
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder=" Confirm Password"
                          name="confirm_password"
                          id="confirmPassword"
                          value={values.confirm_password}
                          onChange={handleChange} />
                           {showConfirmPassword ?
                            <div className="gs-not-visible-group" onClick={handleHideConfirmPassword}>
                            <NotVisible stroke="#7A8996"/>
                          </div> : 
                          <div className="gs-visible-group" onClick={handleShowConfirmPassword}>
                          <Visible fill="#7A8996"/>
                        </div>}
                   </div>
                    {errors?.confirm_password && <p className="small">{errors.confirm_password}</p>}
                    <Button  disabled={errors.firstname || errors.lastname || errors.email || errors.phone_number|| errors.country || errors.username || errors.password || errors.confirm_password}type={'submit'}>
                          Create Account
                    </Button>
            </form>

           <div className="have-account">
                <p>Already have an account?</p>
                <Link to='/login' className="link-text sign-up-link">
                    Sign in
                </Link>
            </div>
        </Card>   
        </div>
  )
}

export default SignUp